/**
 * Mensagem de confirmacao que some sozinha ("Salvo na previa").
 *
 * Toda interacao local da previa precisa de feedback visivel, e um estado por
 * botao viraria seis `useState` + seis `useEffect` por pagina. Aqui e um so:
 * `mostrar(texto)` exibe e agenda o sumico; mostrar de novo reinicia o
 * relogio.
 */

import { useCallback, useEffect, useState } from 'react';

const VISIVEL_MS = 2_400;

export function useFeedbackTemporario(): { readonly mensagem: string | null; readonly mostrar: (texto: string) => void } {
  const [mensagem, setMensagem] = useState<string | null>(null);
  const [versao, setVersao] = useState(0);

  useEffect(() => {
    if (mensagem === null) {
      return undefined;
    }
    const timer = window.setTimeout(() => setMensagem(null), VISIVEL_MS);
    return () => window.clearTimeout(timer);
  }, [mensagem, versao]);

  const mostrar = useCallback((texto: string): void => {
    setMensagem(texto);
    setVersao((v) => v + 1);
  }, []);

  return { mensagem, mostrar };
}
